const nav = {
  home: 'Home',
  about: 'About',
  services: 'Services',
  consulting: 'Consulting',
  products: 'Products',
  contact: 'Contact',
  academy: 'Academy'
};

export default nav;
